<template>
  <div id="app">
    <!-- header -->
    <m-header :tab=1 :noLogin="true" @isLogin="isLogin"></m-header>
    <!-- header end -->
    <!-- main -->
    <div class="main">
      <!-- row-f00 -->
      <div class="row-f00">
        <div class="wp">
          <el-steps :active="1" align-center>
            <el-step title="编写/导入案例" icon="el-icon-edit" description="作者通过平台在线编写案例  或将线下在docm模板中编写的案例直接导入平台"></el-step>
            <el-step title="在线审核" icon="el-icon-upload" description="编审团队在线上完成审核工作团队协作实时同步，批注修改有迹可循"></el-step>
            <el-step title="案例入库、教学应用" icon="el-icon-picture" description="审核通过的案例将发布入库  在线查询浏览案例，获取权限打印下载"></el-step>
          </el-steps>
        </div>
      </div>
      <!-- row-f00 end -->
      <!-- row-f01 -->
      <!-- <div class="row-f01">
        <div class="wp">
          <div class="title">编委会成员</div>
          <g-tit01 title="More"></g-tit01>
          <div class="m-box01">
            <div class="con">
              ban-f01 --
              <div class="ban-f01 fix">
                <ul>
                  <a href="" target="_blank">
                    <li>
                      <div class=" el-col el-col-18">
                        <h3 class="row1">吴青峰</h3>
                        <div class="notice_active row1">运动系统与疾病   主编</div>
                        <div class="notice_active row1">首都医科大学附属北京中医医院</div>
                      </div>
                      <div class=" el-col el-col-6">
                        <div class="headSculpture">
                          <img src="../../../static/images/f-icon017.png">
                        </div>
                      </div>
                    </li>
                  </a>

                  <a href="" target="_blank">
                    <li>
                      <div class=" el-col el-col-18">
                        <h3 class="row1">吴青峰</h3>
                        <div class="notice_active row1">运动系统与疾病   主编</div>
                        <div class="notice_active row1">首都医科大学附属北京中医医院</div>
                      </div>
                      <div class=" el-col el-col-6">
                        <div class="headSculpture">
                          <img src="../../../static/images/f-icon017.png">
                        </div>
                      </div>
                    </li>
                  </a>
                  <a href="" target="_blank">
                    <li>
                      <div class=" el-col el-col-18">
                        <h3 class="row1">吴青峰</h3>
                        <div class="notice_active row1">运动系统与疾病   主编</div>
                        <div class="notice_active row1">首都医科大学附属北京中医医院</div>
                      </div>
                      <div class=" el-col el-col-6">
                        <div class="headSculpture">
                          <img src="../../../static/images/f-icon017.png">
                        </div>
                      </div>
                    </li>
                  </a>
                  <a href="" target="_blank">
                    <li>
                      <div class=" el-col el-col-18">
                        <h3 class="row1">吴青峰</h3>
                        <div class="notice_active row1">运动系统与疾病   主编</div>
                        <div class="notice_active row1">首都医科大学附属北京中医医院</div>
                      </div>
                      <div class=" el-col el-col-6">
                        <div class="headSculpture">
                          <img src="../../../static/images/f-icon017.png">
                        </div>
                      </div>
                    </li>
                  </a>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div> -->
      <!-- row-f01 end -->
      <!-- row-f01 -->
      <div class="row-f02">
        <div class="wp">
          <!-- <div class="title">案例编写文档</div> -->
          <!-- m-box02 -->
          <div class="m-box02">
            <div class="con">
              <!-- ban-f02 -->
              <div class="ban-f02 fix">
                <ul>
                  <li>
                    <div class="img"><img src="../../../static/images/f-icon019.png"></div>
                    <div class="tit02">
                      <h3 class="row1">案例编写与审核系统</h3>
                      <p class="row1">Case Writing &  Auditing System</p>
                    </div>
                  </li>
                  <li>
                    <div class="img"><img src="../../../static/images/f-icon020.png"></div>
                    <div class="tit02">
                      <h3 class="row1">案例编写规范</h3>
                      <p class="row1">Case Preparation Specification</p>
                    </div>
                  </li>
                  <li>
                    <div class="img"><img src="../../../static/images/f-icon021.png"></div>
                    <div class="tit02">
                      <h3 class="row1">案例编写模板</h3>
                      <p class="row1">Case Writing &  Auditing System</p>
                    </div>
                  </li>
                  <li>
                    <div class="img"><img src="../../../static/images/f-icon022.png"></div>
                    <div class="tit02" >
                      <h3 class="row1">案例参考样例</h3>
                      <p class="row1">Case Reference Example</p>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <!-- m-box02 end-->
        </div>
      </div>
      <!-- row-f01 end -->
    </div>
    <!-- main end -->
    <!-- footer -->
    <m-footer></m-footer>
    <!-- footer end -->
  </div>
</template>

<script>
  import mHeader from "../components/mHeader"
  import mFooter from "../components/mFooter"
  import gTit01 from "../components/gTit01"

  export default {
    data: () => {
      return {
        loginFlag: false
      }
    },
    components: {
      mHeader,
      mFooter,
      gTit01
    },
    methods: {
      isLogin(value) {
        this.loginFlag = value
      },
      async goToCaseList(){
        if (this.loginFlag) {
          window.open('./case.html');
        } else {
          location.href = './login.html'
        }
      },
      showCaseRule() {
         window.open('productionDec.html');
      },
      downCaseTemplate() {
        window.open('/cbl/front/case/template/downTemplate');
      },
      showStandardCase() {
        window.open('caseReference.html');
      },
    }
  }
</script>

<style scoped>
.ul-picList01 li {
  cursor: pointer;
}
.row-f00 {
    padding-top: 70px;
    background: #fafafa url(../../../static/images/f-icon015.png) no-repeat;
        padding-bottom: 38px;
}
.row-f01 .title{font-size: 26px;color: #333;text-align: center;font-weight: 500;}

.ban-f01 li{   margin-bottom: 25px; float: left;border:1px solid #939298;    overflow: hidden;width: 100%;    padding: 20px 20px 20px 20px;background: #fff url(../../../static/images/f-icon016.png) no-repeat}
.ban-f01 li h3{margin:0;margin-bottom: 10px;}
.ban-f01 a:nth-child(2){margin-right: 0}
.ban-f01 a:nth-child(4){margin-right: 0}
.headSculpture{text-align: right;float: right;background:#e2e7e6;width:80px;height:80px;border-radius: 100%}
.row1{
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.notice_active{color:#999999;font-size:14px;    font-weight: 500;margin-top:5px}
.headSculpture img{width:80px;height:80px;border-radius: 100%}
.ban-f01 a li:hover{background:#292732 url(../../../static/images/f-icon018.png) no-repeat;color:#FFF}
.ban-f01 a {color:#333;  margin-right: 20px;  overflow: hidden;display: inline-block;width: 48%;}
.row-f02 .title{    position: absolute;top: -15px;z-index: 10;left: 40%;width:260px;height: 65px;margin:0 auto;text-align:center;line-height: 65px;font-size:20px;color:#ffffff;font-weight: bold;background:#4372d1}
.row-f02 {position: relative;}
.row-f02 .ban-f02 li .img{max-height: 320px}
.m-box02{border:none}
.row-f02 .ban-f02 li {cursor: pointer; position: relative;    width: 25%;float: left;}
.row-f02 .ban-f02 li .tit02{position: absolute;bottom:15px;color:#FFF;    padding-left: 5%;}
.row-f02 .ban-f02 li .tit02 h3{font-size: 20px}
</style>
<style>
.el-step__title.is-finish,.el-step__title.is-process,.el-step__title.is-wait
{
  color:#333;
      font-weight: bold;
    font-size: 18px;
        line-height: 65px;
}
.el-icon-edit{background:url(../../../static/images/f-icon012.png) no-repeat;height: 55px;width: 55px;}
.el-icon-edit:before,.el-icon-upload:before,.el-icon-picture:before{content: none}
.el-step__icon.is-icon{width: 55px;}
.el-step__description.is-finish,.el-step__description.is-process,.el-step.is-center .el-step__description{font-size: 14px;color: #666;line-height: 25px;}
.el-step.is-center .el-step__description{padding-left: 22%;padding-right: 22%;}
.el-icon-upload{background:url(../../../static/images/f-icon013.png) no-repeat;height: 55px;width: 55px;}
.el-icon-picture{background:url(../../../static/images/f-icon014.png) no-repeat;height: 55px;width: 55px;}
.g-tit01 .tit01{font-size: 18px;color:#4372d1}
</style>



// WEBPACK FOOTER //
// src/views/index/index.vue